import type { CountryCode } from 'libphonenumber-js'
import parseMobile from 'libphonenumber-js'

import { AREA_CODES_REGEX, BLACKLISTED_NUMBERS } from './constants'

export const validator =
  (countryCode: CountryCode) =>
  (number: string): boolean => {
    const phoneNumber = parseMobile(number, countryCode)

    if (typeof phoneNumber === 'undefined') {
      return false
    }

    // Note: libphonenumber does not filter invalid area codes
    const countryAreaCodeRegex = AREA_CODES_REGEX[countryCode] ?? AREA_CODES_REGEX.DEFAULT
    const validAreaCode = countryAreaCodeRegex.length > 0 ? new RegExp(countryAreaCodeRegex).test(number) : true
    const blacklistNumbers = BLACKLISTED_NUMBERS[countryCode] ?? []
    const inputBlackListed = Array.isArray(blacklistNumbers)
      ? blacklistNumbers.includes(number)
      : blacklistNumbers instanceof RegExp && new RegExp(blacklistNumbers).test(number)
    return phoneNumber.isValid() && !inputBlackListed && validAreaCode
  }

export const isDigitInput = (input: string, currMode: boolean): boolean => {
  if (input.length > 1) {
    const digitsOnlyPattern = /^\d+$/
    const spaceRegex = /\s+/g
    return Boolean(input.replace(spaceRegex, '').match(digitsOnlyPattern))
  } else if (input.length > 0) {
    return currMode
  }

  return false
}

export const transformedValue = (
  maskFun: IMask.MaskedPattern<string>,
  value: string,
  enableInputPhoneMode: boolean,
  isMobileInputMode: boolean,
  country: CountryCode,
  countryRequiredLeadingZero: boolean
): TransformedValueResponse => {
  maskFun.resolve(value)
  const rawValue = maskFun.rawInputValue.startsWith('+') ? maskFun.unmaskedValue : maskFun.rawInputValue
  const isMobileMode = enableInputPhoneMode ? isDigitInput(rawValue, isMobileInputMode) : false
  const viewValue = enableInputPhoneMode && isMobileMode ? maskFun.value : rawValue
  const appendZerosString = countryRequiredLeadingZero && rawValue[0] !== '0' ? '0' : ''
  const countryRawValue = `${appendZerosString}${rawValue}`
  const validate = validator(country)
  const isMobileNumberValid = isMobileMode ? validate(countryRawValue) : false

  return { viewValue, isMobileNumberValid, countryRawValue, isMobileMode, rawValue }
}

export interface TransformedValueResponse {
  isMobileMode: boolean
  countryRawValue: string
  rawValue: string
  isMobileNumberValid: boolean
  viewValue: string
}
